import React, { useState, useMemo, useEffect } from "react";
import { Printer, Download } from "lucide-react";

import { getApplications } from "../api/applicationsService";
import { Badge } from "../components/common";

export default function ApplicationsList({ onOpen }) {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  const [taluka, setTaluka] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadApplications();
  }, []);

  const loadApplications = async () => {
    try {
      const data = await getApplications();
      setApplications(data.recentTeachers);
      console.log(data);
      console.log('applicationId', data.applicationId);
      console.log('teacher', data.recentTeachers[0]);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const talukas = [...new Set(applications.map(x => x.taluka))];

  const categories = [...new Set(applications.map(x => x.category))];

  const statuses = [...new Set(applications.map(x => x.status))];

  const filtered = useMemo(() => {
    return applications.filter(
      (a) =>
        (!taluka || a.taluka === taluka) &&
        (!category || a.category === category) &&
        (!status || a.status === status) &&
        (!search ||
          a.name.toLowerCase().includes(search.toLowerCase()) ||
          a.applicationNumber
            .toLowerCase()
            .includes(search.toLowerCase()))
    );
  }, [applications, taluka, category, status, search]);

  const exportCSV = () => {
    const rows = [
      [
        "Application No",
        "Teacher",
        "Mobile",
        "School",
        "Taluka",
        "Category",
        "Status",
        "Marks",
        "Submitted On",
      ],
    ];

    filtered.forEach((a) => {
      rows.push([
        a.applicationNumber,
        a.teacherName,
        a.mobile,
        a.school,
        a.taluka,
        a.category,
        a.status,
        a.score ?? "",
        a.submittedOn
          ? new Date(a.submittedOn).toLocaleDateString()
          : "",
      ]);
    });

    const csv = rows
      .map((r) => r.map((v) => `"${v ?? ""}"`).join(","))
      .join("\n");

    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "applications.csv";
    a.click();
  };

  if (loading)
    return <div className="p-8 text-center">Loading...</div>;

  return (
    <div className="p-6">
      <div className="flex justify-between mb-5">
        <div>
          <h1 className="text-2xl font-semibold">
            अर्ज व्यवस्थापन
          </h1>

          <p className="text-slate-500">
            एकूण {applications.length} अर्ज
          </p>
        </div>

        {/* <button
          onClick={exportCSV}
          className="bg-amber-400 px-4 py-2 rounded-lg flex items-center gap-2"
        >
          <Download size={16} />
          CSV
        </button> */}
      </div>

      {/* <div className="grid grid-cols-4 gap-3 mb-5">
        <select
          value={taluka}
          onChange={(e) => setTaluka(e.target.value)}
          className="border rounded-lg p-2"
        >
          <option value="">All Talukas</option>

          {talukas.map((t) => (
            <option key={t}>{t}</option>
          ))}
        </select>

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="border rounded-lg p-2"
        >
          <option value="">All Categories</option>

          {categories.map((c) => (
            <option key={c}>{c}</option>
          ))}
        </select>

        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border rounded-lg p-2"
        >
          <option value="">All Status</option>

          {statuses.map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>

        <input
          placeholder="Search..."
          className="border rounded-lg p-2"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div> */}

      <div className="bg-white rounded-xl border overflow-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-800 text-white">
            <tr>
              <th className="p-3 text-left">Application No</th>
              <th className="p-3 text-left">Teacher</th>
              <th className="p-3 text-left">Mobile</th>
              <th className="p-3 text-left">School</th>
              <th className="p-3 text-left">Taluka</th>
              <th className="p-3 text-left">Category</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Marks</th>
              {/* <th className="p-3 text-left">Submitted</th> */}
              {/* <th className="p-3"></th> */}
            </tr>
          </thead>

          <tbody>
            {filtered.map((a) => (
              <tr
                key={a.applicationId}
                onClick={() => onOpen(a.applicationId)}
                className="border-b hover:bg-slate-50 cursor-pointer"
              >
                <td className="p-3">{a.applicationNumber}</td>

                <td className="p-3">{a.name}</td>

                <td className="p-3">{a.mobile}</td>

                <td className="p-3">{a.school}</td>

                <td className="p-3">{a.taluka}</td>

                <td className="p-3">{a.category}</td>

                <td className="p-3">
                  <Badge status={a.status} />
                </td>

                <td className="p-3">{a.reviewedScore ?? "-"} / {a.score ?? "-" }</td>

                {/* <td className="p-3">
                  {a.submittedOn
                    ? new Date(a.submittedOn).toLocaleDateString("mr-IN")
                    : "-"}
                </td> */}

                {/* <td className="p-3">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      window.print();
                    }}
                    className="border rounded p-1 hover:bg-slate-100"
                  >
                    <Printer size={14} />
                  </button>
                </td> */}
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td
                  colSpan={10}
                  className="text-center py-8 text-slate-500"
                >
                  No applications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}